"use client";

import { c as _c } from "react/compiler-runtime";
import { Collapse } from "@/components/Collapse/Collapse.component";
import { LoadMoreRepliesButton } from "@/components/Comment/components/list/LoadMoreRepliesButton.component";
import { CommentThread } from "@/components/Comment/components/thread/CommentThread.component";
import { useComment } from "@/components/Comment/context/comment.context";
export function CommentReplies() {
  const $ = _c(13);
  const {
    comment,
    thread,
    depth
  } = useComment();
  const replies = comment.replies.comments;
  const hasMoreToLoad = comment.replies.hasNextPage && comment.replies.endCursor !== null;
  if (replies.length === 0) {
    return null;
  }
  const t0 = thread.isRepliesExpanded;
  let t1;
  if ($[0] !== depth || $[1] !== replies) {
    let t2;
    if ($[3] !== depth) {
      t2 = reply => <CommentThread comment={reply} depth={depth + 1} key={reply.id} />;
      $[3] = depth;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = replies.map(t2);
    $[0] = depth;
    $[1] = replies;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== hasMoreToLoad) {
    t2 = hasMoreToLoad ? <div className="mt-3 flex items-center gap-4"><LoadMoreRepliesButton /></div> : null;
    $[5] = hasMoreToLoad;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <div aria-label="Replies" className="mt-3 ml-1 border-smoke border-l-2 pl-3">{t1}{t2}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t3 || $[11] !== thread.isRepliesExpanded) {
    t4 = <Collapse isExpanded={t0}>{t3}</Collapse>;
    $[10] = t3;
    $[11] = thread.isRepliesExpanded;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}